import REGION_DATA from 'china-area-data'
import { global } from './global'
// code转汉字大对象
const CodeToText = {}
// 汉字转code大对象
const TextToCode = {}
const provinceObject = REGION_DATA['86'] // 省份对象
const regionData = []
let provinceAndCityData = []
CodeToText[''] = '全部'
// 计算省
for (const prop in provinceObject) {
	regionData.push({
		value: prop, // 省份code值
		label: provinceObject[prop] // 省份汉字
	})
	CodeToText[prop] = provinceObject[prop]
	TextToCode[provinceObject[prop]] = {
		code: prop
	}
	TextToCode[provinceObject[prop]]['全部'] = {
		code: ''
	}
}
// 计算市
for (let i = 0, len = regionData.length; i < len; i++) {
	const provinceCode = regionData[i].value
	const provinceText = regionData[i].label
	const provinceChildren = []
	for (const prop in REGION_DATA[provinceCode]) {
		provinceChildren.push({
			value: prop,
			label: REGION_DATA[provinceCode][prop]
		})
		CodeToText[prop] = REGION_DATA[provinceCode][prop]
		TextToCode[provinceText][REGION_DATA[provinceCode][prop]] = {
			code: prop
		}
		TextToCode[provinceText][REGION_DATA[provinceCode][prop]]['全部'] = {
			code: ''
		}
	}
	if (provinceChildren.length) {
		regionData[i].children = provinceChildren
	}
}
provinceAndCityData = global.deepClone(regionData)
// 计算区
for (let i = 0, len = regionData.length; i < len; i++) {
	const province = regionData[i].children
	const provinceText = regionData[i].label
	if (province) {
		for (let j = 0, len = province.length; j < len; j++) {
			const cityCode = province[j].value
			const cityText = province[j].label
			const cityChildren = []
			for (const prop in REGION_DATA[cityCode]) {
				cityChildren.push({
					value: prop,
					label: REGION_DATA[cityCode][prop]
				})
				CodeToText[prop] = REGION_DATA[cityCode][prop]
				TextToCode[provinceText][cityText][REGION_DATA[cityCode][prop]] = {
					code: prop
				}
			}
			if (cityChildren.length) {
				province[j].children = cityChildren
			}
		}
	}
}
// 添加“全部”选项
const provinceAndCityDataPlus = global.deepClone(provinceAndCityData)
provinceAndCityDataPlus.unshift({
	value: '',
	label: '全部'
})
for (let i = 0, len = provinceAndCityDataPlus.length; i < len; i++) {
	const province = provinceAndCityDataPlus[i].children
	if (province && province.length) {
		province.unshift({
			value: '',
			label: '全部'
		})
		for (let j = 0, len = province.length; j < len; j++) {
			const city = province[j].children
			if (city && city.length) {
				city.unshift({
					value: '',
					label: '全部'
				})
			}
		}
	}
}
const regionDataPlus = global.deepClone(regionData)
for (let i = 0, len = regionDataPlus.length; i < len; i++) {
	const province = regionDataPlus[i].children
	if (province && province.length) {
		for (let j = 0, len = province.length; j < len; j++) {
			const city = province[j].children
			if (city && city.length) {
				city.unshift({
					value: regionDataPlus[i].value + '-' + province[j].value + '-',
					label: '全部'
				})
				city.push({
					value: regionDataPlus[i].value + '-' + province[j].value + '-0',
					label: '其它'
				}, {
					value: regionDataPlus[i].value + '-' + province[j].value + '-1',
					label: '不详'
				})
			}
		}
		province.unshift({
			value: regionDataPlus[i].value + '-',
			label: '全部'
		})
	}
}
regionDataPlus.unshift({
	value: '',
	label: '全部'
})
/**
 * @method    根据获取的地址编码,得到对应省市区信息
 * @param addressData    地区数据
 * @param addressCode    地区对应编码
 */
function getRegionValue(addressData, addressCode) {
	let regionValue = ''
	const i = 0
	regionValue = loopAddressData(addressData, addressCode, i, regionValue)
	return regionValue
}
/**
 * @method    根据获取的地址编码,处理数据
 */
function loopAddressData(addressData, addressCode, i, regionValue) {
	addressData.map((item) => {
		if (addressCode[i] === item.value) {
			regionValue = i === 0 ? item.label : regionValue + '/' + item.label
			if (i < addressCode.length && item.children) {
				regionValue = loopAddressData(item.children, addressCode, i + 1, regionValue)
			}
		}
	})
	return regionValue
}
export { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode, getRegionValue }
